export default function Einleitung() {
  return <section data-section-id="261376" id="einleitung" className="w-full bg-background text-foreground py-16 md:py-24 lg:py-32 px-6 md:px-12 border-b border-primary/20">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center gap-8 md:gap-12">
        {}
        <div className="flex items-center gap-4">
          <div className="h-px w-8 md:w-12 bg-primary"></div>
          <span className="text-xs md:text-sm font-default font-semibold tracking-widest uppercase text-primary">
            Datenschutz
          </span>
          <div className="h-px w-8 md:w-12 bg-primary"></div>
        </div>

        {}
        <blockquote className="text-2xl md:text-4xl lg:text-6xl font-default font-bold leading-relaxed md:leading-relaxed lg:leading-tight text-foreground">
          Ihre Privatsphäre ist uns wichtig. Wir schützen Ihre Daten mit modernster Technologie und höchster Sorgfalt.
        </blockquote>

        {}
        <p className="text-base md:text-xl font-default text-muted-foreground max-w-2xl mt-4">
          Bei CHROTECH verpflichten wir uns dem Schutz Ihrer persönlichen Informationen. Erfahren Sie hier, wie wir Daten erheben, verarbeiten und Ihre Rechte wahren.
        </p>
      </div>
    </section>;
}